class SignInPresenter {
  constructor(view, signInUseCase) {
    this.view = view;
    this.signInUseCase = signInUseCase;
    this.change = {};
  }

  onChange(value, field) {
    this.change[field] = value;
  }

  async submit() {
    try {
      const user = {
        ...this.change,
      };
      this.view.showProgress();
      const signedInUser = await this.signInUseCase.execute(user);

      const role = signedInUser.roles[0].id;

      switch (role) {
        case "Admin":
        case "HR":
          this.view.navigateTo("/");
          break;
        // case "HR":
        //   this.view.navigateTo("/");
        //   break;
        case "Recruiter":
          this.view.navigateTo("/recruiter/online-applicants");
          break;
        case "Coordinator":
          this.view.navigateTo("/coordinator/calendar");
          break;
        case "Applicants":
          this.view.navigateTo("/signin");
          break;
        case "Accounting":
          this.view.navigateTo("/accounting/last_pay");
          break;
        case "Employee":
          this.view.navigateTo("/employee/profile");
          break;
        case "queueing":
          this.view.navigateTo("/queue");
          break;
        case "Guard":
          this.view.navigateTo("/qr-scanner");
          break;
        default:
          this.view.navigateTo("/admin/employees");
          break;
      }
      this.view.reload();
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }
}

export default SignInPresenter;
